/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BusinessProfile =
  | 'BUYER'
  | 'SUPPLIER';

export type InvoiceData = {
  comment?: string | null | undefined;
  reference?: string | null | undefined;
  revisedReference?: string | null | undefined;
  revisedTotalExclTax?: number | null | undefined;
  revisedTotalInclTax?: number | null | undefined;
  totalExclTax?: number | null | undefined;
  totalInclTax?: number | null | undefined;
};

export type UpsertDocumentOfOrderInput = {
  domain: string;
  invoice?: InvoiceData | null | undefined;
  orderId: string;
  orderReferenceId: string;
  path: string;
  type: string;
  userBusinessProfile: BusinessProfile;
};

export type UpsertDocumentOfOrderMutationVariables = Exact<{
  data: Types.UpsertDocumentOfOrderInput;
}>;


export type UpsertDocumentOfOrderMutation = { upsertDocumentOfOrder: { success: boolean } | null };


export const UpsertDocumentOfOrderDocument = /*#__PURE__*/ gql`
    mutation UpsertDocumentOfOrder($data: UpsertDocumentOfOrderInput!) {
  upsertDocumentOfOrder(data: $data) {
    success
  }
}
    `;
export type UpsertDocumentOfOrderMutationFn = Apollo.MutationFunction<UpsertDocumentOfOrderMutation, UpsertDocumentOfOrderMutationVariables>;

/**
 * __useUpsertDocumentOfOrderMutation__
 *
 * To run a mutation, you first call `useUpsertDocumentOfOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDocumentOfOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDocumentOfOrderMutation, { data, loading, error }] = useUpsertDocumentOfOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertDocumentOfOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDocumentOfOrderMutation, UpsertDocumentOfOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDocumentOfOrderMutation, UpsertDocumentOfOrderMutationVariables>(UpsertDocumentOfOrderDocument, options);
      }
export type UpsertDocumentOfOrderMutationHookResult = ReturnType<typeof useUpsertDocumentOfOrderMutation>;
export type UpsertDocumentOfOrderMutationResult = Apollo.MutationResult<UpsertDocumentOfOrderMutation>;
export type UpsertDocumentOfOrderMutationOptions = Apollo.BaseMutationOptions<UpsertDocumentOfOrderMutation, UpsertDocumentOfOrderMutationVariables>;